import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Table } from '../../components/ui/Table';
import { ArrowLeft, ArrowRight, Save, Upload, Check } from 'lucide-react';
interface ProgramCreateProps {
  onCancel: () => void;
  onSuccess: () => void;
}
export function ProgramCreate({
  onCancel,
  onSuccess
}: ProgramCreateProps) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    type: 'SPHP',
    startDate: '',
    endDate: '',
    commodity: 'Beras',
    quota: ''
  });
  const steps = [{
    num: 1,
    label: 'Identitas Program'
  }, {
    num: 2,
    label: 'Parameter & Aturan'
  }, {
    num: 3,
    label: 'Kuota & Wilayah'
  }, {
    num: 4,
    label: 'Kanal Penyaluran'
  }, {
    num: 5,
    label: 'Review & Approval'
  }];
  const handleNext = () => setStep(prev => Math.min(prev + 1, 5));
  const handleBack = () => setStep(prev => Math.max(prev - 1, 1));
  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <div className="space-y-4 max-w-2xl" data-id="element-521">
            <Input label="Nama Program" placeholder="Contoh: SPHP Beras Q3 2025" value={formData.name} onChange={e => setFormData({
            ...formData,
            name: e.target.value
          })} data-id="element-522" />
            <div className="grid grid-cols-2 gap-4" data-id="element-523">
              <Select label="Tipe Program" options={[{
              value: 'SPHP',
              label: 'SPHP (Stabilisasi Harga)'
            }, {
              value: 'Bantuan Pangan',
              label: 'Bantuan Pangan'
            }, {
              value: 'CPP',
              label: 'Pengadaan CPP'
            }]} value={formData.type} onChange={e => setFormData({
              ...formData,
              type: e.target.value
            })} data-id="element-524" />
              <Input label="Nomor Surat Penugasan" placeholder="Nomor SK/Perpres" data-id="element-525" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-526">
              <Input type="date" label="Tanggal Mulai" data-id="element-527" />
              <Input type="date" label="Tanggal Selesai" data-id="element-528" />
            </div>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-529">
              <Upload className="mx-auto text-gray-400 mb-2" data-id="element-530" />
              <p className="text-sm font-medium text-gray-900" data-id="element-531">
                Upload Dokumen Dasar
              </p>
              <p className="text-xs text-gray-500" data-id="element-532">
                PDF, Max 10MB (SK, Juknis)
              </p>
              <Button size="sm" variant="outline" className="mt-4" data-id="element-533">
                Pilih File
              </Button>
            </div>
          </div>;
      case 2:
        return <div className="space-y-4 max-w-2xl" data-id="element-534">
            <Select label="Komoditas" options={[{
            value: 'Beras',
            label: 'Beras'
          }, {
            value: 'Jagung',
            label: 'Jagung'
          }, {
            value: 'Kedelai',
            label: 'Kedelai'
          }]} data-id="element-535" />
            <div className="grid grid-cols-2 gap-4" data-id="element-536">
              <Select label="Kemasan" options={[{
              value: '5kg',
              label: 'Karung 5kg'
            }, {
              value: '10kg',
              label: 'Karung 10kg'
            }, {
              value: '50kg',
              label: 'Karung 50kg'
            }]} data-id="element-537" />
              <Select label="Standar Mutu" options={[{
              value: 'Premium',
              label: 'Premium'
            }, {
              value: 'Medium',
              label: 'Medium'
            }, {
              value: 'Standard',
              label: 'Standard'
            }]} data-id="element-538" />
            </div>
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-100" data-id="element-539">
              <h4 className="font-medium text-bulog-blue mb-2" data-id="element-540">
                Aturan Harga (HET)
              </h4>
              <div className="grid grid-cols-2 gap-4" data-id="element-541">
                <Input label="Zona 1 (Jawa, Lampung, Sumsel)" placeholder="Rp 10.900" data-id="element-542" />
                <Input label="Zona 2 (Sumatera, Kalimantan)" placeholder="Rp 11.500" data-id="element-543" />
                <Input label="Zona 3 (Maluku, Papua)" placeholder="Rp 11.800" data-id="element-544" />
              </div>
            </div>
          </div>;
      case 3:
        return <div className="space-y-4" data-id="element-545">
            <div className="flex justify-between items-end" data-id="element-546">
              <div className="w-1/3" data-id="element-547">
                <Input label="Total Target Nasional (Ton)" placeholder="0" data-id="element-548" />
              </div>
              <div className="space-x-2" data-id="element-549">
                <Button variant="outline" size="sm" data-id="element-550">
                  Download Template
                </Button>
                <Button variant="secondary" size="sm" data-id="element-551">
                  Import CSV
                </Button>
              </div>
            </div>

            <Table columns={[{
            header: 'Provinsi',
            accessor: 'prov'
          }, {
            header: 'Target (Ton)',
            accessor: 'target'
          }, {
            header: 'Gudang Utama',
            accessor: 'wh'
          }]} data={[{
            prov: 'DKI Jakarta',
            target: '50,000',
            wh: 'Gudang Kelapa Gading'
          }, {
            prov: 'Jawa Barat',
            target: '120,000',
            wh: 'Gudang Cibitung'
          }, {
            prov: 'Jawa Timur',
            target: '115,000',
            wh: 'Gudang Buduran'
          }]} keyExtractor={i => i.prov} data-id="element-552" />
          </div>;
      case 4:
        return <div className="space-y-6" data-id="element-553">
            <div className="grid grid-cols-2 gap-6" data-id="element-554">
              <Card title="Kanal Retail (SPHP)" className="h-full" data-id="element-555">
                <div className="space-y-2" data-id="element-556">
                  <label className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded" data-id="element-557">
                    <input type="checkbox" checked className="rounded text-bulog-blue" data-id="element-558" />
                    <span data-id="element-559">Pasar Tradisional (Pencatatan Manual)</span>
                  </label>
                  <label className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded" data-id="element-560">
                    <input type="checkbox" checked className="rounded text-bulog-blue" data-id="element-561" />
                    <span data-id="element-562">Retail Modern (API Integration)</span>
                  </label>
                  <label className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded" data-id="element-563">
                    <input type="checkbox" checked className="rounded text-bulog-blue" data-id="element-564" />
                    <span data-id="element-565">RPK (Rumah Pangan Kita)</span>
                  </label>
                </div>
              </Card>
              <Card title="Mitra Distribusi" className="h-full" data-id="element-566">
                <div className="space-y-2" data-id="element-567">
                  <label className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded" data-id="element-568">
                    <input type="checkbox" checked className="rounded text-bulog-blue" data-id="element-569" />
                    <span data-id="element-570">PT Pos Indonesia</span>
                  </label>
                  <label className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded" data-id="element-571">
                    <input type="checkbox" checked className="rounded text-bulog-blue" data-id="element-572" />
                    <span data-id="element-573">DNR Logistics</span>
                  </label>
                </div>
              </Card>
            </div>
          </div>;
      case 5:
        return <div className="space-y-6" data-id="element-574">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-start gap-3" data-id="element-575">
              <Check className="text-green-600 mt-1" data-id="element-576" />
              <div data-id="element-577">
                <h4 className="font-bold text-green-900" data-id="element-578">
                  Siap untuk Persetujuan
                </h4>
                <p className="text-green-700 text-sm" data-id="element-579">
                  Program akan disimpan sebagai Draft dan dikirim ke Direksi
                  untuk persetujuan.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-580">
              <div data-id="element-581">
                <h4 className="text-sm font-medium text-gray-500 uppercase mb-2" data-id="element-582">
                  Ringkasan Program
                </h4>
                <div className="bg-gray-50 p-4 rounded-lg space-y-3" data-id="element-583">
                  <div className="flex justify-between" data-id="element-584">
                    <span className="text-gray-500" data-id="element-585">Nama:</span>
                    <span className="font-medium" data-id="element-586">
                      {formData.name || 'SPHP Beras Q3 2025'}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-587">
                    <span className="text-gray-500" data-id="element-588">Tipe:</span>
                    <span className="font-medium" data-id="element-589">{formData.type}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-590">
                    <span className="text-gray-500" data-id="element-591">Komoditas:</span>
                    <span className="font-medium" data-id="element-592">{formData.commodity}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-593">
                    <span className="text-gray-500" data-id="element-594">Total Kuota:</span>
                    <span className="font-medium" data-id="element-595">285,000 Ton</span>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div className="space-y-6" data-id="element-596">
      <div className="flex items-center gap-4 mb-6" data-id="element-597">
        <button onClick={onCancel} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-598">
          <ArrowLeft size={20} data-id="element-599" />
        </button>
        <div data-id="element-600">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-601">
            Buat Program Baru
          </h1>
          <p className="text-gray-500" data-id="element-602">Wizard pembuatan program penugasan</p>
        </div>
      </div>

      {/* Progress Steps */}
      <div className="mb-8" data-id="element-603">
        <div className="flex items-center justify-between relative" data-id="element-604">
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-1 bg-gray-200 -z-10" data-id="element-605"></div>
          {steps.map(s => <div key={s.num} className="flex flex-col items-center bg-white px-2" data-id="element-606">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm mb-2 transition-colors ${step >= s.num ? 'bg-bulog-blue text-white shadow-lg' : 'bg-gray-200 text-gray-500'}`} data-id="element-607">
                {s.num}
              </div>
              <span className={`text-xs font-medium ${step >= s.num ? 'text-bulog-blue' : 'text-gray-500'}`} data-id="element-608">
                {s.label}
              </span>
            </div>)}
        </div>
      </div>

      <Card className="min-h-[400px]" data-id="element-609">{renderStepContent()}</Card>

      <div className="flex justify-between pt-4 border-t border-gray-200" data-id="element-610">
        <Button variant="ghost" onClick={onCancel} data-id="element-611">
          Batal
        </Button>
        <div className="flex gap-3" data-id="element-612">
          {step > 1 && <Button variant="outline" onClick={handleBack} data-id="element-613">
              Kembali
            </Button>}
          {step < 5 ? <Button onClick={handleNext} icon={<ArrowRight size={16} data-id="element-615" />} data-id="element-614">
              Lanjut
            </Button> : <Button onClick={onSuccess} icon={<Save size={16} data-id="element-617" />} data-id="element-616">
              Simpan & Ajukan
            </Button>}
        </div>
      </div>
    </div>;
}